<template>
  <div>
    <v-dialog v-model="dialog" max-width="800" scrollable persistent>
      <v-card :disabled="isLoading">
        <v-card-title>
          Cartes
          <v-spacer/>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider/>

        <v-card-text class="pa-8">


          <v-tabs background-color="transparent" color="gifty" v-model="tab" class="mb-5" grow>
            <v-tab>
              <v-icon left>mdi-pencil-box-outline</v-icon>
              Saisie manuelle
            </v-tab>
            <v-tab>
              <v-icon left>mdi-qrcode-scan</v-icon>
              Scan
            </v-tab>
          </v-tabs>

          <div v-if="tab === 0" class="table-border pa-15 rounded-lg">
            <div v-for="(code, i) in codes" :key="i" class="d-flex align-center mb-2 justify-center">
              <v-text-field
                  outlined
                  hide-details="auto"
                  v-model.trim="codes[i]"
                  label="Code *"
                  :error-messages="errors['codes.' + i]"
                  @input="clearError(i)"
                  clearable
              ></v-text-field>
              &nbsp;
              <v-btn depressed color="gifty" dark icon @click="codes.push('')">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <v-btn depressed color="gifty" dark icon
                     :disabled="codes.length === 1"
                     @click="codes.splice(i,1)">
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </div>

            <v-row align="center" justify="center" class="mt-3">
              <v-col cols="12" lg="6">
                <v-btn depressed
                       large
                       dark
                       @click="addCards"
                       :loading="btnLoading"
                       color="gifty"
                       block>
                  <v-icon left>mdi-content-save</v-icon>
                  Enregistrer
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <div v-if="tab === 1" class="table-border pa-15 rounded-lg text-center">
            <v-icon color="gifty" size="80">mdi-qrcode-scan</v-icon>
          </div>

          <v-skeleton-loader v-if="isLoading"
                             class="mt-5"
                             type="text,text,text,text,text,text,text,text,text,text"></v-skeleton-loader>

          <div v-else class="mt-5">


            <v-list two-line>

              <v-list-item class="table-border rounded-lg mb-2"
                           v-for="(card,index) in cards"
                           :key="index"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="card.voucher.code"></v-list-item-title>
                  <v-list-item-subtitle>
                    <span class="gifty-text font-weight-medium">
                         {{ card.voucher.amount }} Pts
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn icon color="red">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <v-alert color="info" text v-if="cards.length">
              <div class="d-flex align-center justify-space-between">
                <div>
                  <v-icon left large color="info">mdi-information</v-icon>
                  {{ cards.length }} carte(s) associée(s) à ce colis.
                </div>
                <div>
                  <v-btn
                      :loading="btnLoading2"
                      color="info"
                      depressed
                      :disabled="parcel.status !== 'created'"
                      @click="deliver"
                  >
                    <v-icon left>
                      {{ parcel.status === 'created' ? 'mdi-truck-delivery' : 'mdi-check-circle' }}
                    </v-icon>
                    {{ parcel.status === 'created' ? 'Livrer le colis' : 'Déjà livré' }}
                  </v-btn>
                </div>
              </div>
            </v-alert>

          </div>

        </v-card-text>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";

export default {
  data() {
    return {
      dialog: false,
      tab: null,
      isLoading: false,
      btnLoading: false,
      btnLoading2: false,
      parcel: {},
      codes: [""],
      cards: [],
      errors: {},
    };
  },
  methods: {
    open(item) {
      this.codes = [""]
      this.cards = []
      this.tab = 0
      this.dialog = true
      this.errors = {}
      this.parcel = item
      this.getCards()
    },
    clearError(index) {
      if (this.errors['codes.' + index]) {
        this.$delete(this.errors, 'codes.' + index);
      }
    },
    addCards() {
      this.btnLoading = true
      this.errors = {}
      HTTP.post("/v1/refill-card-delivery/parcels/" + this.parcel.id + "/cards/attach", {
        codes: this.codes
      }).then(() => {
        this.btnLoading = false
        this.$successMessage = "Cet élément a été modifié avec succès.";
        this.codes = [""]
        this.$emit('refresh')
        this.getCards();
      }).catch((err) => {
        this.btnLoading = false
        if (err.response && err.response.status === 422) {
          this.errors = err.response.data.errors;
        }
        console.log(err);
      });
    },
    deliver() {
      this.btnLoading2 = true
      HTTP.post("/v1/refill-card-delivery/parcels/" + this.parcel.id + "/cards/delivery").then(() => {
        this.btnLoading2 = false
        this.$successMessage = "Parcel delivered successfully!";
        this.$emit('refresh')
        this.dialog =  false;
      }).catch((err) => {
        this.btnLoading2 = false
        this.$errorMessage = "Failed to deliver parcel.";
        console.log(err);
      });
    },
    getCards() {
      this.isLoading = true
      HTTP.get("/v1/refill-card-delivery/parcels/" + this.parcel.id + "/cards").then((res) => {
        this.isLoading = false
        this.cards = res.data.data
      }).catch((err) => {
        this.isLoading = false
        console.log(err);
      });
    },
  },
};
</script>

<style scoped>

</style>